/* unplugin-vue-components disabled */import script from "./Purchaserecord.vue?vue&type=script&setup=true&name=Purchaserecord&lang=js"
export * from "./Purchaserecord.vue?vue&type=script&setup=true&name=Purchaserecord&lang=js"

const __exports__ = script;

export default __exports__